// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2oQll","cell":"ColumnAccessor_cell__2X4uO","firstCellAccent":"ColumnAccessor_firstCellAccent__1lOQz"};